import useFetch from '@hooks/useFetch';
import { processCourse } from '@api/processors/course';

const useLearnerCoursesInfo = (
  username,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `v1/user/${username}/completed_courses_v2/`;

  const {
    data: learnerCoursesInfo,
    isValidating,
    ...rest
  } = useFetch(
    username ? key : null,
    {},
    { fallbackData: options.fallbackData }
  );

  if (learnerCoursesInfo?.results?.length)
    learnerCoursesInfo.results = learnerCoursesInfo.results.map(processCourse);

  if (options.selector && typeof options.selector === 'function')
    return options.selector(learnerCoursesInfo || []);
  return {
    key,
    learnerCoursesInfo,
    isValidating,
    ...rest
  };
};

export default useLearnerCoursesInfo;
